import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

export interface getMessagesParameter extends ApiParameter {
    orderHistoryId: string;
    size: number;
}

export interface MessageCollectionModel {
    uri: string;
    id: string;
    body: string;
    subject: string;
    dateToDisplay: string;
    isRead: boolean;
    displayName: string;
    properties: Properties;
}

export interface Properties {}

const url = "/api/v2/orderhistory/GetMessageCollection";

export const getMessages = async (parameter: getMessagesParameter) => {
    const response = await get<MessageCollectionModel[]>(`${url}?date=${new Date().toISOString()}`, parameter);
    return response;
};
